import React, { ReactElement } from 'react';
import { Button, Space } from 'antd';
import styles from './Error404.module.less';
import TypographyText from '../../tmp/TypographyText';
import NotFound from '@severalnines/frontend_hub/libs/icons/src/lib/ilustrations/NotFound';
import { getThemeIllustrationColor } from '../../core/helpers';

type Error404Props = {
    onHomeClick?: () => void;
    testId?: string;
};

/**
 * Error 404 Page
 */
function Error404({ onHomeClick, testId }: Error404Props): ReactElement {
    return (
        <Space
            direction="vertical"
            data-testid={testId}
            className={styles.Error404Base}
        >
            <NotFound style={{ color: getThemeIllustrationColor() }} />
            <Space direction="vertical" className={styles.Error404Details}>
                <h1 className={styles.Error404DetailsTitle}>Page not found</h1>
                <Space direction="vertical" size={40}>
                    <TypographyText>
                        The content you're looking for doesn't exist. Either it
                        was removed, or you mistyped the link.
                    </TypographyText>
                    <Button type="primary" onClick={onHomeClick}>
                        Go to home
                    </Button>
                </Space>
            </Space>
        </Space>
    );
}

export default Error404;
